import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03bc229a&scoped=true&lang=pug"
import script from "./wl-dialog-import.js?vue&type=script&lang=js&external"
export * from "./wl-dialog-import.js?vue&type=script&lang=js&external"
import style0 from "./wl-dialog-import.styl?vue&type=style&index=0&id=03bc229a&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc229a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bc229a')) {
      api.createRecord('03bc229a', component.options)
    } else {
      api.reload('03bc229a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03bc229a&scoped=true&lang=pug", function () {
      api.rerender('03bc229a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-dialog-import/index.vue"
export default component.exports